export const ImmigrationGurusSvg = {
  rankingSvg: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      // xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_387_857"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_387_857)">
        <path
          d="M4.875 15C4.5625 15 4.29688 14.8906 4.07812 14.6719C3.85937 14.4531 3.75 14.1875 3.75 13.875V11.625C3.75 11.3125 3.85937 11.0469 4.07812 10.8281C4.29688 10.6094 4.5625 10.5 4.875 10.5C5.1875 10.5 5.45312 10.6094 5.67188 10.8281C5.89062 11.0469 6 11.3125 6 11.625V13.875C6 14.1875 5.89062 14.4531 5.67188 14.6719C5.45312 14.8906 5.1875 15 4.875 15ZM9.375 15C9.0625 15 8.79688 14.8906 8.57812 14.6719C8.35938 14.4531 8.25 14.1875 8.25 13.875V7.875C8.25 7.5625 8.35938 7.29688 8.57812 7.07812C8.79688 6.85938 9.0625 6.75 9.375 6.75C9.6875 6.75 9.95312 6.85938 10.1719 7.07812C10.3906 7.29688 10.5 7.5625 10.5 7.875V13.875C10.5 14.1875 10.3906 14.4531 10.1719 14.6719C9.95312 14.8906 9.6875 15 9.375 15ZM13.875 15C13.5625 15 13.2969 14.8906 13.0781 14.6719C12.8594 14.4531 12.75 14.1875 12.75 13.875V4.125C12.75 3.8125 12.8594 3.54688 13.0781 3.32812C13.2969 3.10937 13.5625 3 13.875 3C14.1875 3 14.4531 3.10937 14.6719 3.32812C14.8906 3.54688 15 3.8125 15 4.125V13.875C15 14.1875 14.8906 14.4531 14.6719 14.6719C14.4531 14.8906 14.1875 15 13.875 15Z"
          fill="#868686"
        />
      </g>
    </svg>
  ),
  schoolSvg: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      // xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_387_862"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_387_862)">
        <path
          d="M15.7492 11.9999V7.57493L9.71172 10.8562C9.48672 10.9812 9.24922 11.0437 8.99922 11.0437C8.74922 11.0437 8.51172 10.9812 8.28672 10.8562L1.94922 7.40618C1.81172 7.33118 1.71484 7.23743 1.65859 7.12493C1.60234 7.01243 1.57422 6.88743 1.57422 6.74993C1.57422 6.61243 1.60234 6.48743 1.65859 6.37493C1.71484 6.26243 1.81172 6.16868 1.94922 6.09368L8.28672 2.64368C8.39922 2.58118 8.51484 2.5343 8.63359 2.50305C8.75234 2.4718 8.87422 2.45618 8.99922 2.45618C9.12422 2.45618 9.24609 2.4718 9.36484 2.50305C9.48359 2.5343 9.59922 2.58118 9.71172 2.64368L16.8555 6.54368C16.9805 6.60618 17.0773 6.6968 17.1461 6.81555C17.2148 6.9343 17.2492 7.06243 17.2492 7.19993V11.9999C17.2492 12.2124 17.1773 12.3906 17.0336 12.5343C16.8898 12.6781 16.7117 12.7499 16.4992 12.7499C16.2867 12.7499 16.1086 12.6781 15.9648 12.5343C15.8211 12.3906 15.7492 12.2124 15.7492 11.9999ZM8.28672 15.3562L4.53672 13.3312C4.28672 13.1937 4.09297 13.0062 3.95547 12.7687C3.81797 12.5312 3.74922 12.2749 3.74922 11.9999V9.14993L8.28672 11.6062C8.51172 11.7312 8.74922 11.7937 8.99922 11.7937C9.24922 11.7937 9.48672 11.7312 9.71172 11.6062L14.2492 9.14993V11.9999C14.2492 12.2749 14.1805 12.5312 14.043 12.7687C13.9055 13.0062 13.7117 13.1937 13.4617 13.3312L9.71172 15.3562C9.59922 15.4187 9.48359 15.4656 9.36484 15.4968C9.24609 15.5281 9.12422 15.5437 8.99922 15.5437C8.87422 15.5437 8.75234 15.5281 8.63359 15.4968C8.51484 15.4656 8.39922 15.4187 8.28672 15.3562Z"
          fill="#868686"
        />
      </g>
    </svg>
  ),
  locationSvg: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      // xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_387_867"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_387_867)">
        <path
          d="M9 15.75C7.79037 15.75 6.8005 15.5959 6.03038 15.2878C5.26012 14.9796 4.875 14.5807 4.875 14.0914C4.875 13.8586 4.98487 13.6357 5.20462 13.4228C5.42425 13.2099 5.72544 13.0289 6.10819 12.8798L6.69806 13.3804C6.48944 13.4591 6.27381 13.5634 6.05119 13.6933C5.82856 13.8231 5.68937 13.9509 5.63362 14.0769C5.71925 14.3251 6.08225 14.5409 6.72263 14.7246C7.363 14.9082 8.12212 15 9 15C9.86825 15 10.6257 14.9082 11.2723 14.7246C11.9189 14.5409 12.2851 14.3251 12.3707 14.0769C12.3313 13.9481 12.1876 13.8188 11.9394 13.689C11.6913 13.5591 11.4567 13.4548 11.2356 13.3759L11.8211 12.8711C12.2385 13.0231 12.5601 13.2056 12.786 13.4184C13.012 13.6314 13.125 13.8558 13.125 14.0914C13.125 14.5807 12.7399 14.9796 11.9696 15.2878C11.1995 15.5959 10.2096 15.75 9 15.75ZM9 13.5C7.4875 12.3539 6.35938 11.2404 5.61563 10.1597C4.87187 9.07881 4.5 8.01819 4.5 6.97781C4.5 6.19619 4.63531 5.51181 4.90594 4.92469C5.17669 4.33769 5.52838 3.84562 5.961 3.4485C6.39375 3.05137 6.87694 2.75238 7.41056 2.5515C7.94419 2.3505 8.474 2.25 9 2.25C9.526 2.25 10.0558 2.3505 10.5894 2.5515C11.1231 2.75238 11.6063 3.05137 12.039 3.4485C12.4716 3.84562 12.8233 4.33769 13.0941 4.92469C13.3647 5.51181 13.5 6.19619 13.5 6.97781C13.5 8.01819 13.1281 9.07881 12.3844 10.1597C11.6406 11.2404 10.5125 12.3539 9 13.5ZM9 8.09137C9.33563 8.09137 9.62144 7.97575 9.85744 7.7445C10.0936 7.51325 10.2116 7.225 10.2116 6.87975C10.2116 6.54425 10.0936 6.25844 9.85744 6.02231C9.62144 5.78631 9.33563 5.66831 9 5.66831C8.674 5.66831 8.39056 5.78631 8.14969 6.02231C7.90881 6.25844 7.78837 6.54425 7.78837 6.87975C7.78837 7.225 7.90881 7.51325 8.14969 7.7445C8.39056 7.97575 8.674 8.09137 9 8.09137Z"
          fill="#868686"
        />
      </g>
    </svg>
  ),
  intakeSvg: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      // xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_387_872"
        // style="mask-type:alpha"s
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_387_872)">
        <path
          d="M7.5 9C6.675 9 5.96875 8.70625 5.38125 8.11875C4.79375 7.53125 4.5 6.825 4.5 6C4.5 5.175 4.79375 4.46875 5.38125 3.88125C5.96875 3.29375 6.675 3 7.5 3C8.325 3 9.03125 3.29375 9.61875 3.88125C10.2063 4.46875 10.5 5.175 10.5 6C10.5 6.825 10.2063 7.53125 9.61875 8.11875C9.03125 8.70625 8.325 9 7.5 9ZM3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64688 14.2656 1.5 13.9125 1.5 13.5V12.9C1.5 12.4875 1.60625 12.1 1.81875 11.7375C2.03125 11.375 2.325 11.1 2.7 10.9125C3.3375 10.5875 4.05625 10.3125 4.85625 10.0875C5.65625 9.8625 6.5375 9.75 7.5 9.75H7.99688C8.15313 9.75 8.3125 9.7625 8.475 9.7875C8.725 9.8125 8.8875 9.94375 8.9625 10.1812C9.0375 10.4187 8.9875 10.625 8.8125 10.8L8.49375 11.1187C8.10625 11.5062 7.8875 11.9625 7.8375 12.4875C7.7875 13.0125 7.90625 13.4937 8.19375 13.9312C8.34375 14.1687 8.36562 14.4062 8.25937 14.6438C8.15312 14.8813 7.975 15 7.725 15H3ZM11.6625 13.2L14.925 9.9375C15.0625 9.8 15.2375 9.73125 15.45 9.73125C15.6625 9.73125 15.8375 9.8 15.975 9.9375C16.1125 10.075 16.1813 10.25 16.1813 10.4625C16.1813 10.675 16.1125 10.85 15.975 10.9875L12.1875 14.775C12.0375 14.925 11.8625 15 11.6625 15C11.4625 15 11.2875 14.925 11.1375 14.775L9.6 13.2375C9.4625 13.1 9.39375 12.925 9.39375 12.7125C9.39375 12.5 9.4625 12.325 9.6 12.1875C9.7375 12.05 9.9125 11.9813 10.125 11.9813C10.3375 11.9813 10.5125 12.05 10.65 12.1875L11.6625 13.2Z"
          fill="#868686"
        />
      </g>
    </svg>
  ),
  currencySvg: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_387_877"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_387_877)">
        <path
          d="M9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69687 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69687 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69687 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69687 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM8.98125 14.25C9.15625 14.25 9.30938 14.1844 9.44063 14.0531C9.57188 13.9219 9.6375 13.7688 9.6375 13.5938V13.3125C10.2625 13.2 10.8 12.9563 11.25 12.5813C11.7 12.2063 11.925 11.65 11.925 10.9125C11.925 10.3875 11.775 9.90625 11.475 9.46875C11.175 9.03125 10.575 8.65 9.675 8.325C8.925 8.075 8.40625 7.85625 8.11875 7.66875C7.83125 7.48125 7.6875 7.225 7.6875 6.9C7.6875 6.575 7.80313 6.31875 8.03438 6.13125C8.26563 5.94375 8.6 5.85 9.0375 5.85C9.2875 5.85 9.50625 5.89375 9.69375 5.98125C9.88125 6.06875 10.0375 6.1875 10.1625 6.3375C10.2875 6.4875 10.4281 6.59063 10.5844 6.64688C10.7406 6.70312 10.8875 6.7 11.025 6.6375C11.2125 6.5625 11.3406 6.43438 11.4094 6.25313C11.4781 6.07188 11.4625 5.90625 11.3625 5.75625C11.1625 5.46875 10.9156 5.225 10.6219 5.025C10.3281 4.825 10.0125 4.7125 9.675 4.6875V4.40625C9.675 4.23125 9.60938 4.07812 9.47812 3.94688C9.34687 3.81562 9.19375 3.75 9.01875 3.75C8.84375 3.75 8.69063 3.81562 8.55938 3.94688C8.42813 4.07812 8.3625 4.23125 8.3625 4.40625V4.6875C7.7375 4.825 7.25 5.1 6.9 5.5125C6.55 5.925 6.375 6.3875 6.375 6.9C6.375 7.4875 6.54688 7.9625 6.89062 8.325C7.23438 8.6875 7.775 9 8.5125 9.2625C9.3 9.55 9.84688 9.80625 10.1531 10.0312C10.4594 10.2563 10.6125 10.55 10.6125 10.9125C10.6125 11.325 10.4656 11.6281 10.1719 11.8219C9.87813 12.0156 9.525 12.1125 9.1125 12.1125C8.7875 12.1125 8.49375 12.0344 8.23125 11.8781C7.96875 11.7219 7.75 11.4875 7.575 11.175C7.475 11 7.34375 10.8813 7.18125 10.8188C7.01875 10.7563 6.85625 10.7563 6.69375 10.8188C6.51875 10.8813 6.39062 11 6.30937 11.175C6.22813 11.35 6.225 11.5188 6.3 11.6812C6.5 12.1062 6.76875 12.4531 7.10625 12.7219C7.44375 12.9906 7.85 13.175 8.325 13.275V13.5938C8.325 13.7688 8.39062 13.9219 8.52188 14.0531C8.65313 14.1844 8.80625 14.25 8.98125 14.25Z"
          fill="#868686"
        />
      </g>
    </svg>
  ),
  entryScore: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <circle cx="9" cy="9" r="8" stroke="#868686" stroke-width="2" />
      <path
        d="M6 9.5L8 11.5L12 7"
        stroke="#868686"
        stroke-width="2"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  worlddesignSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.00244 13.75C6.06906 13.75 5.1915 13.5729 4.36975 13.2186C3.54813 12.8644 2.83337 12.3836 2.2255 11.7764C1.61763 11.1691 1.13644 10.455 0.781937 9.634C0.427312 8.81312 0.25 7.93594 0.25 7.00244C0.25 6.06906 0.427125 5.1915 0.781375 4.36975C1.13562 3.54812 1.61637 2.83337 2.22362 2.2255C2.83087 1.61762 3.545 1.13644 4.366 0.781937C5.18687 0.427312 6.06406 0.25 6.99756 0.25C7.93094 0.25 8.8085 0.427126 9.63025 0.781376C10.4519 1.13563 11.1666 1.61638 11.7745 2.22363C12.3824 2.83088 12.8636 3.545 13.2181 4.366C13.5727 5.18688 13.75 6.06406 13.75 6.99756C13.75 7.93094 13.5729 8.8085 13.2186 9.63025C12.8644 10.4519 12.3836 11.1666 11.7764 11.7745C11.1691 12.3824 10.455 12.8636 9.634 13.2181C8.81312 13.5727 7.93594 13.75 7.00244 13.75ZM6.25 12.9625V11.5C5.8375 11.5 5.48438 11.3531 5.19063 11.0594C4.89687 10.7656 4.75 10.4125 4.75 10V9.25L1.15 5.65C1.1125 5.875 1.07812 6.1 1.04688 6.325C1.01562 6.55 1 6.775 1 7C1 8.5125 1.49687 9.8375 2.49062 10.975C3.48438 12.1125 4.7375 12.775 6.25 12.9625ZM11.425 11.05C11.675 10.775 11.9 10.4781 12.1 10.1594C12.3 9.84063 12.4656 9.50937 12.5969 9.16562C12.7281 8.82187 12.8281 8.46875 12.8969 8.10625C12.9656 7.74375 13 7.375 13 7C13 5.76775 12.6617 4.64238 11.9853 3.62388C11.3089 2.60538 10.3971 1.87113 9.25 1.42113V1.75C9.25 2.1625 9.10313 2.51562 8.80938 2.80938C8.51562 3.10313 8.1625 3.25 7.75 3.25H6.25V4.75C6.25 4.9625 6.17812 5.14062 6.03438 5.28438C5.89062 5.42812 5.7125 5.5 5.5 5.5H4V7H8.5C8.7125 7 8.89062 7.07188 9.03438 7.21563C9.17813 7.35938 9.25 7.5375 9.25 7.75V10H10C10.325 10 10.6188 10.0969 10.8813 10.2906C11.1438 10.4844 11.325 10.7375 11.425 11.05Z"
        fill="#868686"
      />
    </svg>
  ),
  educationSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
    >
      <path
        d="M12.9411 8.53855V4.17111L6.99889 7.38467L0.306641 3.74998L6.99889 0.115295L13.6911 3.74998V8.53855H12.9411ZM6.99889 11.0192L2.49889 8.57305V5.5153L6.99889 7.96161L11.4989 5.5153V8.57305L6.99889 11.0192Z"
        fill="#868686"
      />
    </svg>
  ),
  filterSvgIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <mask
        id="mask0_2102_14164"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="25"
      >
        <rect x="0.871094" y="0.201172" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2102_14164)">
        <path
          d="M12.255 19.7012C12.0037 19.7012 11.7934 19.6165 11.6243 19.4472C11.4549 19.278 11.3703 19.0678 11.3703 18.8164V13.0282L5.77226 5.91667C5.57992 5.66017 5.55201 5.39351 5.68851 5.11667C5.82517 4.83967 6.05567 4.70117 6.38001 4.70117H19.3605C19.6848 4.70117 19.9153 4.83967 20.052 5.11667C20.1885 5.39351 20.1606 5.66017 19.9683 5.91667L14.3703 13.0282V18.8164C14.3703 19.0678 14.2856 19.278 14.1163 19.4472C13.9471 19.6165 13.7368 19.7012 13.4855 19.7012H12.255Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  ),
};
